import React from 'react';
import PropTypes from 'prop-types';
import {Alert, AlertTitle, Typography, Button, Box} from '@mui/material';
import { secondaryPanelSx } from '../styles/secondaryMsiStyles';
import { isModuleLoadError } from '../utils/moduleLoadError';

export function ModuleLoadNotice({ onReload }) {
    return (
        <Alert severity="warning" sx={{ my: 1 }}>
            <AlertTitle>Part of the app could not load</AlertTitle>
            This component could not be downloaded after an app update or a connection interruption.
            Save or copy any unsaved work, then reload the page to try again.
            <Box sx={{ mt: 1 }}>
                <Button variant="outlined" color="inherit" size="small" onClick={onReload}>
                    Reload Page
                </Button>
            </Box>
        </Alert>
    );
}

ModuleLoadNotice.propTypes = {
    onReload: PropTypes.func.isRequired,
};

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, error: null};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true, error};
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            if (isModuleLoadError(this.state.error)) {
                return <ModuleLoadNotice onReload={this.handleReload} />;
            }
            if (this.props.moduleOnly) {
                throw this.state.error;
            }
            return (
                <Box textAlign="center" mt={5} mx="auto" p={3} maxWidth={560} sx={secondaryPanelSx}>
                    <Typography variant="h5" color="error" gutterBottom>
                        Something went wrong.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {this.state.error && this.state.error.toString()}
                    </Typography>
                    <Button variant="contained" color="primary" onClick={this.handleReload}>
                        Reload Page
                    </Button>
                </Box>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    moduleOnly: PropTypes.bool,
};

export default ErrorBoundary;
